import { render, staticRenderFns } from "./ApiWeb.vue?vue&type=template&id=37a8ab70&"
import script from "./ApiWeb.vue?vue&type=script&lang=js&"
export * from "./ApiWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports